import Vue from 'vue';
import Vuex from "vuex";
import moment from "moment";
import AppDataSetting from '@/data/app-data-setting.js'

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    UI: {
      dialog: {
        // 檢視日誌
        taskWorkingItemDetail: {
          isShow: false,
          id: -1
        },
        // taskWorkingItemDetailInProject 檢視專案時檢視日誌
        taskWorkingItemDetailInProject: {
          isShow: false,
          id: -1
        },
        // 安排工單
        workOrderDetail: {
          isShow: false,
          id: -1
        },
        // 假單
        leaveFormDetail: {
          isShow: false,
          id: -1
        },
        // 薪資明細
        salaryDetail: {
          isShow: false,
          id: -1
        },
        // 專案甘特圖
        projectGantt: {
          isShow: false,
          id: -1
        },
        // 專案
        project: {
          isShow: false,
          id: -1,
          defaultOpenTaskTab: false
        },
        projectEditor: {
          isShow: false,
          id: -1
        },
        // 補休
        compensatoryTimeDetail: {
          isShow: false,
          id: -1
        },
      }
    },
    myID: null,
    user: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    userSalary: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    userPosition: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    userDepartment: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    announcement: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    county: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    client: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    department: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    project: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    task: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    taskWorkingItem: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    projectDepartmentBudget: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    todoItem: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    notification: {
      // list: [],
      // isFetched: false,
      // isFetching: false, isReloaded: false,
      unread: {
        list: [],
        isFetched: false,
        isFetching: false,
        isReloaded: false,
      },
      readed: {
        list: [],
        isFetched: false,
        isFetching: false,
        isReloaded: false,
        totalCount: -1,
      }
    },
    deviceInfo: {
      subscription: null, // chrome webpush subscription
      token: null, // APNS token
    },
    workOrder: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    leaveForm: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    salary: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
    compensatoryTime: {
      list: [],
      isFetched: false,
      isFetching: false,
      isReloaded: false
    },
  },
  getters: {
    // *** data ***
    // notifications
    newNotifications: state => {
      return state.notification.unread.list;
    },
    readedNotifications: state => {
      return state.notification.readed.list;
    },
    unreadCount: (state, getters) => {
      return getters.newNotifications.filter(o => !o.ViewedAt).length;
    },
    // county
    countries: state => {
      return state.county.list;
    },
    activeCountyList: (state, getters) => {
      return getters.countries.filter(o => o.IsActive)
    },
    // client
    clients: state => {
      return state.client.list
    },
    activeClientList: state => {
      return state.client.list.filter(o => o.IsActive)
    },
    // department
    departments: state => {
      return state.department.list;
    },
    activeDepartmentList: (state, getters) => {
      return getters.departments.filter(o => o.IsActive)
    },
    // announcement
    announcements: state => {
      return state.announcement.list;
    },
    // project
    projects: state => {
      return state.project.list;
    },
    projectsMap: state => {
      var m = {}
      for(let o of state.project.list) {
        m[o.ID] = o
      }
      return m
    },
    projectDepartmentBudgets: state => {
      return state.projectDepartmentBudget.list;
    },
    // 2023/02/01 發現主管開啟工作日誌頁面緩慢。因此依據project id 製作 map
    projectDepartmentBudgetsMapOfProject: state => {
      var m = {}
      for(let o of state.projectDepartmentBudget.list) {
        if (!m[o.ProjectID])m[o.ProjectID] = []
        m[o.ProjectID].push(o)
      }
      return m
    },
    // tasks
    tasks: state => {
      return state.task.list;
    },
    tasksMap: state => {
      var m = {}
      for(let o of state.task.list) {
        m[o.ID] = o
      }
      return m
    },
    tasksMapOfProject: state => {
      var m = {}
      for(let o of state.task.list) {
        if(!m[o.ProjectID])m[o.ProjectID] = []
        m[o.ProjectID].push(o)
      }
      return m
    },
    activeTaskList: (state, getters) => {
      return getters.tasks.filter(o => o.IsActive)
    },
    taskWorkingItems: state => {
      return state.taskWorkingItem.list;
    },
    taskWorkingItemsMap: state => {
      var m = {}
      for(let o of state.taskWorkingItem.list) {
        m[o.ID] = o
      }
      return m
    },
    taskWorkingItemsMapOfTask: state => {
      var m = {}
      for(let o of state.taskWorkingItem.list) {
        if(!m[o.TaskID])m[o.TaskID] = []
        m[o.TaskID].push(o)
      }
      return m
    },
    activeTaskWorkingItems: (state, getters) => {
      return getters.taskWorkingItems.filter(o => o.IsActive);
    },
    todoTaskWorkingItemCount: (state, getters) => {

      let isDepartmentManagerReviewable = item => {
        return (
          getters.myLevel == 10 &&
          (item.Status == "主管確認中" || item.Status == "獎金退回")
        );
      }
      let isDepartmentManagerVerifiable = item => {
        return getters.myLevel == 10 && item.Status == "審核預排中";
      }
      let isManagerReviewable = item => {
        return getters.myLevel > 100 && item.Status == "獎金簽核中";
      }

      const findTaskWorkingItemDepartmentID = o =>
        AppDataSetting.attachTaskWorkingItemTask({'$store':{state, getters}}, o).DepartmentID;

      if (getters.myLevel > 100) return state.taskWorkingItem.list.filter(isManagerReviewable).length;
      if (getters.myLevel == 10) return state.taskWorkingItem.list.filter(o => findTaskWorkingItemDepartmentID(o) == getters.myDepartment.ID && (isDepartmentManagerReviewable(o) || isDepartmentManagerVerifiable(o))).length;
      return state.taskWorkingItem.list.filter(o => o.Status == '').length;
    },
    // user
    users: state => {
      return state.user.list;
    },
    activeUsers: state => {
      return state.user.list.filter(o => o.IsActive);
    },
    userPositions: state => {
      return state.userPosition.list;
    },
    userDepartments: state => {
      return state.userDepartment.list;
    },
    userSalaries: state => {
      return state.userSalary.list;
    },
    leaveForms: state => {
      return state.leaveForm.list;
    },
    compensatoryTimes: state => {
      return state.compensatoryTime.list;
    },
    workOrders: state => {
      return state.workOrder.list;
    },
    me: state => {
      if (!state.myID) return { Profile: {} }
      return state.user.list.find(o => o.ID === state.myID) || { Profile: {} };
    },
    myLevel: state => {
      if (!state.myID) return 0;
      return (state.userPosition.list.find(o => o.UserID === state.myID) || {}).Level;
    },
    myDepartment: (state, getters) => {
      if (!state.myID) return {};
      let departmentID = (
        getters.userDepartments.find(o => o.UserID == state.myID) || {}
      ).DepartmentID;
      return getters.departments.find(o => o.ID == departmentID) || {};
    },
    // todoItem
    todoItems: (state) => {
      return state.todoItem.list;
    },
    doingTodoItemCount: (state, getters) => {
      return getters.todoItems.filter(o => !o.DoneAt).length
    },
    // work order
    todoWorkOrderCount: (state, getters) => {
      const canApprove = o => o.Status == "收受部門確認中" && getters.myLevel == 10 && getters.myDepartment.ID == o.ReceivedDepartmentID
      const canClose = o => (o.Status == "收受部門拒絕" || o.Status == "收受部門確認中" && moment(o.AlertTime) < moment()) && getters.myLevel > 10
      const canReviewBudget = o => o.Status == "預算審核中" && getters.myLevel > 10
      const canReviewReward = o => o.Status == "獎金審核中" && getters.myLevel > 10
      const canReviewResult = o => (o.Status == "成果審核中" || o.Status == "獎金被退回") && getters.myLevel == 10 && getters.myDepartment.ID == o.InitiatedDepartmentID
      const canReport = o => (o.Status == "進行中" || o.Status == "退回成果") && getters.me.ID == o.UserID

      return state.workOrder.list.filter(o => canApprove(o) || 
        canClose(o) ||
        canReviewBudget(o) ||
        canReviewReward(o) ||
        canReviewResult(o) ||
        canReport(o)
      ).length;
    },
    // leave form
    todoLeaveFormCount: (state, getters) => {
      if (getters.myLevel > 100) return 0
      let amIAgent = o => o.Status == '代理人確認中' && o.AgentID == getters.me.ID
      let amIManager = o => getters.myLevel == 10 && o.Status == '主管確認中' && o.DepartmentID == getters.myDepartment.ID
      let amIAccounting = o => getters.myLevel == 100 && o.Status == '人資審核中'
      return state.leaveForm.list.filter(o => amIAgent(o) || amIManager(o) || amIAccounting(o)).length;
    },
    // compensatoryTime
    todoCompensatoryTimeCount: (state, getters) => {
      if (getters.myLevel != 10) return 0
      const findUserDepartmentID = userID =>
        (getters.userDepartments.find(o => o.UserID == userID) || {})
          .DepartmentID;
      return state.compensatoryTime.list.filter(o =>o.Status=='審核中' && findUserDepartmentID(o.UserID) == getters.myDepartment.ID).length;
    },
    // *** permission ***
    canEditProject: (state, getters) => {
      return getters.myLevel >= 10
    },
    canCloseProject: (state, getters) => {
      return getters.myLevel >= 10
    },
    canEditProjectBudget: (state, getters) => {
      return getters.myLevel >= 1000
    },
    canEditTask: (state, getters) => {
      return getters.myLevel == 10 || getters.myLevel >= 1000 // 總經理以上皆可編輯，除非已經送出審核
    },
    canEditClient: (state, getters) => {
      return getters.myLevel >= 10
    },
    canEditCounty: (state, getters) => {
      return getters.myLevel >= 10
    },
    canEditDepartment: (state, getters) => {
      return getters.myLevel >= 100
    },
    canEditUser: (state, getters) => {
      return getters.myLevel >= 100
    },
    canEditReceipt: (state, getters) => {
      return getters.myLevel >= 100
    },
    canEditAnnouncement: (state, getters) => {
      return getters.myLevel >= 10
    },
    canEditWorkOrder: (state, getters) => {
      return getters.myLevel != 100
    },
  },
  mutations: {},
  actions: {
    canEditTaskWorkingItem: ({getters}, taskWorkingItem) => {
      let me = getters.me
      let myLevel = getters.myLevel
      let item = taskWorkingItem
      if (myLevel >= 1000 && item.Status != '已完成') return true; // 總經理以上都可以編輯
      return (myLevel == 10 && item.Status != '已完成') || (myLevel == 1 && (item.Status == '審核預排中' || item.Status == '主管確認中') && item.UserID == me.ID)  // 2023/10 突然說員工新增任務，主管確認前也要能編輯
    },
  },
  modules: {}
});

export default store;

const initialStateCopy = JSON.parse(JSON.stringify(store.state))

export function resetState() {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)))
}